<template>
	<el-tabs type="border-card" class="h-100 no-scroll">
		<el-tab-pane class="mt-2" v-for="(menu, index) in menuList" :key="index" :label="menu.name">
			<component :is="menu.tag" class="px-3 pb-2" :scrId="scrId"></component>
		</el-tab-pane>
	</el-tabs>
</template>

<script>
import FreeFormView from '@qms/TabSample/Content/Table/TableInner/FreeFormView.vue';
import FreeFormViewTwo from '@qms/TabSample/Content/Table/TableInner/FreeFormViewTwo.vue';
import GridView from '@qms/TabSample/Content/Table/TableInner/GridView.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			menuList: [
				{ tag: 'free-form-view', name: 'free form' },
				{ tag: 'free-form-view-two', name: 'free form 2' },
				{ tag: 'grid-view', name: 'grid view' }
			]
		};
	},
	components: {
		FreeFormView,
		FreeFormViewTwo,
		GridView
	},
	methods: {}
};
</script>

<style></style>
